import axios from 'axios'
import jsonWebToken from 'Services/jsonWebToken'
import { apiUrl } from 'Services/accessUrl'
import { ApiResult, ApiDashActivityResult, ApiDashServiceTypeResult, ApiDashCompanyResult, ApiDashRateResult } from 'Types'

const endpoint = `${apiUrl.stable}/dash-fornecedor`


/** Returns ServiceType  */
export const getServiceType = ():ApiResult<ApiDashServiceTypeResult[]> => {
  const url = `${endpoint}/listar`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { headers })
}

/** Returns activity  */
export const getActivity = (filters):ApiResult<ApiDashActivityResult> => {
  const url = `${endpoint}/atividades/obtem`

  const headers = {
    ...jsonWebToken.header
  }
  const params =  filters


  return axios.get(url, { headers, params })
}


/** Returns company info  */
export const getCompany = ():ApiResult<ApiDashCompanyResult> => {
  const url = `${endpoint}/empresa/obtem`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { headers })
}

/** Returns company info  */
export const getRate = ():ApiResult<ApiDashRateResult> => {
  const url = `${endpoint}/avaliacao/obtem`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { headers })
}